/**
 * Build A Crate — DOM helpers + cart / checkout.
 * Not used by subscription-product or subscription-common.js.
 */
(function (global) {
  'use strict';

  function getPlanCardVisibilityTarget(el) {
    if (!el || !el.matches || !el.matches('[data-plan-card]')) return el;
    return el.closest('.swiper-slide') || el;
  }

  function isHidden(el) {
    if (!el) return true;
    var target = getPlanCardVisibilityTarget(el);
    var hidden = target.getAttribute('data-bac-hidden');
    if (hidden === 'true') return true;
    if (hidden === 'false') return false;
    return target.hasAttribute('hidden') || target.classList.contains('d-none');
  }

  function setHidden(el, hidden) {
    if (!el) return;
    var target = getPlanCardVisibilityTarget(el);
    target.setAttribute('data-bac-hidden', hidden ? 'true' : 'false');
    target.classList.toggle('d-none', hidden);
    if (hidden) {
      target.setAttribute('hidden', '');
      target.style.setProperty('display', 'none', 'important');
    } else {
      target.removeAttribute('hidden');
      target.style.removeProperty('display');
    }
  }

  function isPlanSelected(card) {
    return !!card && card.getAttribute('data-bac-plan-selected') === 'true';
  }

  function setPlanSelected(card, selected) {
    if (!card) return;
    card.setAttribute('data-bac-plan-selected', selected ? 'true' : 'false');
    card.classList.toggle('selected', selected);
    var planInput = card.querySelector('[data-bac-plan-card-input]');
    if (planInput) planInput.checked = selected;
  }

  function getSelectedPlanCard(root) {
    root = root || document;
    var cards = root.querySelectorAll('[data-plan-card][data-bac-plan-selected="true"]');
    for (var i = 0; i < cards.length; i++) {
      if (!isHidden(cards[i])) return cards[i];
    }
    return null;
  }

  function queryVisiblePlanCards(root) {
    root = root || document;
    var cards = root.querySelectorAll('[data-plan-card]');
    var visible = [];
    for (var i = 0; i < cards.length; i++) {
      if (!isHidden(cards[i])) visible.push(cards[i]);
    }
    return visible;
  }

  function queryAddons(options) {
    options = options || {};
    var selector = '[data-product-addon]';
    if (options.itemType) selector += '[data-item-type="' + options.itemType + '"]';
    if (options.added) selector += '[data-added="true"]';
    return document.querySelectorAll(selector);
  }

  function queryAddon(itemType, addedOnly) {
    var selector = '[data-product-addon]';
    if (itemType) selector += '[data-item-type="' + itemType + '"]';
    if (addedOnly) selector += '[data-added="true"]';
    return document.querySelector(selector);
  }

  function isPriceHidden(el) {
    if (!el) return true;
    if (el.getAttribute('data-bac-price-hidden') === 'true') return true;
    if (el.getAttribute('data-bac-price-hidden') === 'false') return false;
    return isHidden(el);
  }

  function setPriceHidden(el, hidden) {
    if (!el) return;
    el.setAttribute('data-bac-price-hidden', hidden ? 'true' : 'false');
    setHidden(el, hidden);
  }

  function setPriceDiscounted(el, discounted) {
    if (!el) return;
    el.setAttribute('data-bac-price-discounted', discounted ? 'true' : 'false');
    el.classList.toggle('sp-price-new', discounted);
    el.classList.toggle('text-secondary', discounted);
    el.classList.toggle('fw-bold', discounted);
  }

  function isThumbnailVisible(el) {
    return !!el && el.getAttribute('data-bac-thumbnail-visible') === 'true';
  }

  function setThumbnailVisible(el, visible) {
    if (!el) return;
    el.setAttribute('data-bac-thumbnail-visible', visible ? 'true' : 'false');
    el.classList.toggle('visible', visible);
  }

  function isThumbnailActive(el) {
    return !!el && el.getAttribute('data-bac-thumbnail-active') === 'true';
  }

  function setThumbnailActive(el, active) {
    if (!el) return;
    el.setAttribute('data-bac-thumbnail-active', active ? 'true' : 'false');
    el.classList.toggle('active', active);
  }

  function isAtcDisabled(btn) {
    return !!btn && btn.getAttribute('data-bac-atc-disabled') === 'true';
  }

  function isAtcSoldOut(btn) {
    return !!btn && btn.getAttribute('data-bac-atc-soldout') === 'true';
  }

  function isAtcLoading(btn) {
    return !!btn && btn.getAttribute('data-bac-atc-loading') === 'true';
  }

  function setAtcState(btn, state) {
    if (!btn) return;
    state = state || {};
    if (state.disabled != null) {
      btn.setAttribute('data-bac-atc-disabled', state.disabled ? 'true' : 'false');
      btn.classList.toggle('disabled', state.disabled);
      btn.disabled = state.disabled;
    }
    if (state.soldout != null) {
      btn.setAttribute('data-bac-atc-soldout', state.soldout ? 'true' : 'false');
      btn.classList.toggle('soldout', state.soldout);
    }
    if (state.loading != null) {
      btn.setAttribute('data-bac-atc-loading', state.loading ? 'true' : 'false');
      btn.classList.toggle('loading', state.loading);
    }
  }

  function isFreqOptionsOpen(wrap) {
    if (!wrap) return false;
    if (wrap.getAttribute('data-bac-freq-open') === 'true') return true;
    return wrap.classList.contains('open');
  }

  function setFreqOptionsOpen(wrap, open) {
    if (!wrap) return;
    wrap.setAttribute('data-bac-freq-open', open ? 'true' : 'false');
    wrap.classList.toggle('open', open);
  }

  function isInsideCrateEmpty(accordion) {
    return !!accordion && accordion.getAttribute('data-bac-inside-crate-empty') === 'true';
  }

  function setInsideCrateEmpty(accordion, empty) {
    if (!accordion) return;
    accordion.setAttribute('data-bac-inside-crate-empty', empty ? 'true' : 'false');
    accordion.classList.toggle('sp-inside-crate-accordion--empty', empty);
  }

  function isAccordionContentOpen(content) {
    if (!content) return false;
    if (content.getAttribute('data-bac-accordion-open') === 'true') return true;
    return content.classList.contains('open');
  }

  function getCheckedPurchaseModeInput(root) {
    root = root || document;
    return root.querySelector('[data-bac-purchase-mode-input]:checked');
  }

  global.BuildACrateDom = {
    isHidden: isHidden,
    setHidden: setHidden,
    isPlanSelected: isPlanSelected,
    setPlanSelected: setPlanSelected,
    getSelectedPlanCard: getSelectedPlanCard,
    queryVisiblePlanCards: queryVisiblePlanCards,
    queryAddons: queryAddons,
    queryAddon: queryAddon,
    isPriceHidden: isPriceHidden,
    setPriceHidden: setPriceHidden,
    setPriceDiscounted: setPriceDiscounted,
    isThumbnailVisible: isThumbnailVisible,
    setThumbnailVisible: setThumbnailVisible,
    isThumbnailActive: isThumbnailActive,
    setThumbnailActive: setThumbnailActive,
    isAtcDisabled: isAtcDisabled,
    isAtcSoldOut: isAtcSoldOut,
    isAtcLoading: isAtcLoading,
    setAtcState: setAtcState,
    isFreqOptionsOpen: isFreqOptionsOpen,
    setFreqOptionsOpen: setFreqOptionsOpen,
    isInsideCrateEmpty: isInsideCrateEmpty,
    setInsideCrateEmpty: setInsideCrateEmpty,
    isAccordionContentOpen: isAccordionContentOpen,
    getCheckedPurchaseModeInput: getCheckedPurchaseModeInput
  };

  var dom = global.BuildACrateDom;

  var DEFAULT_CHECKOUT = {
    variantId: null,
    selling_plan_id: null,
    discount_code: '',
    discount_amount: '',
    discount_type: '',
    start_date: '',
    end_date: '',
    per_crate_price: '',
    payFrequency: null,
    shipFrequency: null,
    frequency: 'Monthly',
    subTotal: '',
    productType: 'core',
    productSize: null,
    giftVariantId: null,
    giftNote: '',
    crateName: null,
    crateSKU: null
  };

  var deps = null;

  function getFlow() {
    global.buildACrateFlow = global.buildACrateFlow || {};
    return global.buildACrateFlow;
  }

  function ensureCheckoutState() {
    var flow = getFlow();
    if (!flow.checkout || typeof flow.checkout !== 'object') {
      flow.checkout = Object.assign({}, DEFAULT_CHECKOUT);
    }
    return flow.checkout;
  }

  function mapShipFrequencyToFlowFrequency(shipFreq) {
    var n = parseInt(shipFreq, 10);
    if (n === 1) return 'Monthly';
    if (n === 2) return 'Bi-monthly';
    if (n === 3) return 'Quarterly';
    if (n === 12) return 'Yearly';
    if (Number.isFinite(n)) return n + ' Months';
    return 'Monthly';
  }

  function parseVariantRows(body) {
    var el = body && body.querySelector('[data-main-product-variant]');
    if (!el) return null;
    try {
      var rows = JSON.parse(el.textContent.trim());
      return Array.isArray(rows) ? rows : null;
    } catch (err) {
      return null;
    }
  }

  function getShirtSizeLabelForCheckout() {
    var shirt = dom ? dom.queryAddon('shirt', true) : document.querySelector('[data-product-addon][data-item-type="shirt"][data-added="true"]');
    if (!shirt) return null;
    var sel = shirt.querySelector('[data-item-size]');
    if (sel && sel.options.length) {
      var opt = sel.options[sel.selectedIndex];
      if (opt) {
        var label = (opt.textContent || opt.value || '').trim();
        if (label) return label;
      }
    }
    return shirt.dataset.selectedSize || null;
  }

  function pickVariantRow(rows, preferredSize) {
    if (!rows || !rows.length) return null;

    if (preferredSize) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].variant_title === preferredSize && rows[i].variant_id) return rows[i];
      }
    }

    for (var j = 0; j < rows.length; j++) {
      if (rows[j].variant_title === 'Default Title' && rows[j].variant_id) return rows[j];
    }

    for (var k = 0; k < rows.length; k++) {
      if (rows[k].variant_id) return rows[k];
    }

    return null;
  }

  function isPlanProductAvailable(body) {
    if (!body) return false;
    return body.getAttribute('data-bac-plan-product-available') !== 'false';
  }

  function hasCrateSelectionRequired() {
    return document.querySelector('[data-bac-crate-radio]') !== null;
  }

  function getSelectedCrateWrap() {
    var radio = document.querySelector('[data-bac-crate-radio]:checked');
    return radio ? radio.closest('[data-bac-crate-wrap]') : null;
  }

  function getCrateNameFromSelection() {
    var wrap = getSelectedCrateWrap();
    if (!wrap) return '';
    var label = wrap.querySelector('label[data-drate-name]') || wrap.querySelector('label');
    if (!label) return '';
    return (label.getAttribute('data-drate-name') || label.textContent || '').trim();
  }

  function parseCrateVariantsFromWrap(wrap) {
    if (!wrap) return null;
    var el = wrap.querySelector('[data-bac-crate-variants]');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent.trim());
      return Array.isArray(parsed) ? parsed : null;
    } catch (err) {
      return null;
    }
  }

  var CRATE_SKU_TIER_CODES = ['BSE', 'MTH', 'PRO', 'PMT'];

  function normalizeShirtSizeLabel(productSize) {
    if (!productSize) return '';
    var size = String(productSize).trim();
    var parenIndex = size.indexOf('(');
    if (parenIndex > 0) {
      size = size.slice(0, parenIndex).trim();
    }
    return size;
  }

  function abbreviateSizeForCrateSku(productSize) {
    var size = normalizeShirtSizeLabel(productSize);
    if (!size) return '';

    var explicit = {
      'Youth XS': 'YXS',
      'Youth Extra Small': 'YXS',
      'Youth S': 'YS',
      'Youth Small': 'YS',
      'Youth M': 'YM',
      'Youth Medium': 'YM',
      'Youth L': 'YL',
      'Youth Large': 'YL',
      'Youth XL': 'YXL',
      'Youth Extra Large': 'YXL',
      'Adult XS': 'AXS',
      'Adult Extra Small': 'AXS',
      'Adult S': 'AS',
      'Adult Small': 'AS',
      'Adult M': 'AM',
      'Adult Medium': 'AM',
      'Adult L': 'AL',
      'Adult Large': 'AL',
      'Adult XL': 'AXL',
      'Adult XXL': 'AXXL',
      'Adult 2XL': 'AXXL'
    };

    if (explicit[size]) return explicit[size];

    var shortName = size.match(/\b(\w)/g);
    if (!shortName) return '';
    shortName = shortName.join('');
    if (shortName === 'YX') shortName = 'YM';
    if (size === 'Adult XXL' || size === 'Adult 2XL') shortName = 'AXXL';
    else if (size === 'Adult XL') shortName = 'AXL';
    return shortName;
  }

  function getAddedItemTypes() {
    if (deps && deps.getAddedItemTypes) {
      return deps.getAddedItemTypes();
    }
    var added = [];
    var addonEls = dom ? dom.queryAddons({ added: true }) : document.querySelectorAll('[data-product-addon][data-added="true"]');
    addonEls.forEach(function(el) {
      var type = (el.getAttribute('data-item-type') || '').toLowerCase().trim();
      if (type && added.indexOf(type) < 0) added.push(type);
    });
    return added;
  }

  function resolveCrateSkuTier(hasShirt, hasPro) {
    if (hasShirt && hasPro) {
      return { code: 'PRO', appendSize: true };
    }
    if (hasShirt) {
      return { code: 'MTH', appendSize: true };
    }
    if (hasPro) {
      return { code: 'PMT', appendSize: false };
    }
    return { code: 'BSE', appendSize: false };
  }

  function getFirstAvailableCrateVariantSku(wrap) {
    var variants = parseCrateVariantsFromWrap(wrap);
    if (!variants || !variants.length) return '';

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available !== false && variants[i].sku) {
        return String(variants[i].sku).trim();
      }
    }

    for (var j = 0; j < variants.length; j++) {
      if (variants[j].sku) return String(variants[j].sku).trim();
    }

    return '';
  }

  function stripTierCodeFromPrefix(prefix) {
    if (!prefix) return '';
    var value = String(prefix).trim();
    for (var i = 0; i < CRATE_SKU_TIER_CODES.length; i++) {
      var tier = CRATE_SKU_TIER_CODES[i];
      if (value.length > tier.length && value.slice(-tier.length) === tier) {
        return value.slice(0, -tier.length);
      }
    }
    return value;
  }

  function getVariantSkuPrefixFromWrap(wrap) {
    var variantSku = getFirstAvailableCrateVariantSku(wrap);
    if (!variantSku) return '';

    var dashIndex = variantSku.lastIndexOf('-');
    var baseSegment = dashIndex > 0 ? variantSku.slice(0, dashIndex) : variantSku;
    return stripTierCodeFromPrefix(baseSegment.trim());
  }

  function getDefaultCrateSkuPrefixFromWrap(wrap) {
    // No static fallbacks - SKU prefix must come from:
    // 1. data-bac-crate-sku-prefix-override (manual override in block settings)
    // 2. Gallery product variant SKU (extracted dynamically)
    // 3. data-bac-crate-sku-prefix (computed in Liquid from gallery product)
    console.warn('[Build A Crate] No SKU prefix found for crate. Please configure crate_sku_prefix in block settings or assign a gallery product with valid SKU.');
    return '';
  }

  function getCrateSkuPrefixFromSelection() {
    var wrap = getSelectedCrateWrap();
    if (!wrap) return '';

    var overridePrefix = (wrap.getAttribute('data-bac-crate-sku-prefix-override') || '').trim();
    if (overridePrefix) return overridePrefix;

    var variantPrefix = getVariantSkuPrefixFromWrap(wrap);
    if (variantPrefix) return variantPrefix;

    var configuredPrefix = (wrap.getAttribute('data-bac-crate-sku-prefix') || '').trim();
    if (configuredPrefix) return configuredPrefix;

    return getDefaultCrateSkuPrefixFromWrap(wrap);
  }

  function isAddonAdded(itemType) {
    return !!(dom
      ? dom.queryAddon(itemType, true)
      : document.querySelector('[data-product-addon][data-item-type="' + itemType + '"][data-added="true"]'));
  }

  function resolveCrateSkuTierFromSpType(spType) {
    switch (String(spType || '').trim()) {
      case 'core-shirt-pro':
        return { code: 'PRO', appendSize: true };
      case 'core-shirt':
        return { code: 'MTH', appendSize: true };
      case 'core-pro':
        return { code: 'PMT', appendSize: false };
      default:
        return { code: 'BSE', appendSize: false };
    }
  }

  function resolveCrateSkuTierForCheckout() {
    var hasShirt = isAddonAdded('shirt') || getAddedItemTypes().indexOf('shirt') >= 0;
    var hasPro = isAddonAdded('pro') || getAddedItemTypes().indexOf('pro') >= 0;

    if (hasShirt && hasPro) {
      return resolveCrateSkuTier(true, true);
    }
    if (hasShirt) {
      return resolveCrateSkuTier(true, false);
    }
    if (hasPro) {
      return resolveCrateSkuTier(false, true);
    }

    var flow = getFlow();
    var spType = String(flow.spType || flow.requestedSpType || '').trim();
    if (!spType) {
      var card = getActivePlanCard();
      spType = card ? (card.getAttribute('data-sp-type') || '').trim() : '';
    }
    return resolveCrateSkuTierFromSpType(spType);
  }

  function resolveCrateSku() {
    var prefix = getCrateSkuPrefixFromSelection();
    var tier = resolveCrateSkuTierForCheckout();

    if (!prefix) {
      return getCrateNameFromSelection();
    }

    var sku = prefix + tier.code;
    if (tier.appendSize) {
      var shirtSize = getShirtSizeLabelForCheckout();
      var shortName = abbreviateSizeForCrateSku(shirtSize);
      if (shortName) {
        sku += '-' + shortName;
      }
    }
    return sku;
  }

  function parseGiftVariantId(raw) {
    if (raw == null || raw === '') return null;
    var giftVariantId = parseInt(raw, 10);
    return Number.isFinite(giftVariantId) ? giftVariantId : null;
  }

  function findVisibleGiftBannerForCard(card) {
    if (!card) return null;
    var blockId = card.getAttribute('data-bac-plan-block-id') || '';
    if (!blockId) return null;

    var gifts = document.querySelectorAll('[data-bac-plan-gifts] [data-bac-plan-gift-banner]');
    for (var i = 0; i < gifts.length; i++) {
      var gift = gifts[i];
      if (gift.getAttribute('data-bac-plan-block-id') !== blockId) continue;
      if (dom && dom.isHidden(gift)) continue;
      return gift;
    }
    return null;
  }

  function findGiftBannerForCard(card) {
    if (!card) return null;
    var blockId = card.getAttribute('data-bac-plan-block-id') || '';
    if (!blockId) return null;

    return document.querySelector(
      '[data-bac-plan-gifts] [data-bac-plan-gift-banner][data-bac-plan-block-id="' + blockId + '"]'
    );
  }

  function resolveGiftVariantIdForCheckout(card, body) {
    if (!card || card.getAttribute('data-enable-gifting') !== 'true') return null;

    var giftVariantId = parseGiftVariantId(card.getAttribute('data-bac-gift-variant-id'));
    if (giftVariantId != null) return giftVariantId;

    var visibleBanner = findVisibleGiftBannerForCard(card);
    if (visibleBanner) {
      giftVariantId = parseGiftVariantId(visibleBanner.getAttribute('data-gift-variant-id'));
      if (giftVariantId != null) return giftVariantId;
    }

    if (body) {
      giftVariantId = parseGiftVariantId(body.getAttribute('data-bac-plan-gift-variant-id'));
      if (giftVariantId != null) return giftVariantId;
    }

    var activeBody = body;
    if (!activeBody && deps && card) {
      activeBody = deps.getPlanProductBodyForMode(card, deps.getPurchaseMode());
    }
    if (activeBody && activeBody !== body) {
      giftVariantId = parseGiftVariantId(activeBody.getAttribute('data-bac-plan-gift-variant-id'));
      if (giftVariantId != null) return giftVariantId;
    }

    var giftBody = card.querySelector('[data-bac-plan-body][data-bac-plan-gift-variant-id]');
    if (giftBody) {
      giftVariantId = parseGiftVariantId(giftBody.getAttribute('data-bac-plan-gift-variant-id'));
      if (giftVariantId != null) return giftVariantId;
    }

    var banner = findGiftBannerForCard(card);
    if (banner) {
      giftVariantId = parseGiftVariantId(banner.getAttribute('data-gift-variant-id'));
      if (giftVariantId != null) return giftVariantId;
    }

    return parseGiftVariantId(getFlow().giftVariantId);
  }

  function resolveSellingPlanIdForCheckout(row) {
    if (!row) return null;

    var sellingPlanRaw = String(row.selling_plan_id || '').trim();
    if (!sellingPlanRaw) return null;

    var sellingPlanId = parseInt(sellingPlanRaw, 10);
    return Number.isFinite(sellingPlanId) && sellingPlanId > 0 ? sellingPlanId : null;
  }

  function syncCheckout() {
    if (!deps) return false;

    var checkout = ensureCheckoutState();
    var card = getActivePlanCard();
    if (!card) return false;

    var purchaseMode = deps.getPurchaseMode();
    var body = deps.getPlanProductBodyForMode(card, purchaseMode);
    if (!body) return false;

    var rows = parseVariantRows(body);
    if (!rows || !rows.length) return false;

    var shirtSize = getShirtSizeLabelForCheckout();
    var hasShirtAddon = !!isAddonAdded('shirt');
    if (hasShirtAddon && !shirtSize) return false;

    var row = pickVariantRow(rows, shirtSize);
    if (!row || !row.variant_id) return false;

    checkout.variantId = parseInt(row.variant_id, 10);
    checkout.selling_plan_id = resolveSellingPlanIdForCheckout(row);
    var activeDateDiscount =
      typeof BuildACrateDiscounts !== 'undefined'
        ? BuildACrateDiscounts.resolveActiveDateDiscount(body)
        : null;
    if (activeDateDiscount) {
      checkout.discount_code = activeDateDiscount.code || '';
      checkout.discount_amount = activeDateDiscount.amount || '';
      checkout.discount_type = activeDateDiscount.type || '';
    } else {
      checkout.discount_code = row.discount_code || '';
      checkout.discount_amount = row.discount_amount || '';
      checkout.discount_type = row.discount_Type || '';
    }
    checkout.start_date = row.start_date || '';
    checkout.end_date = row.end_date || '';
    checkout.per_crate_price = row.per_crate_price || '';

    var selection = deps.readPlanCardSelection(card);
    checkout.payFrequency = selection
      ? parseInt(selection.payFrequency, 10)
      : parseInt(body.getAttribute('data-bac-plan-pay-frequency'), 10);
    checkout.shipFrequency = selection
      ? parseInt(selection.shipFrequency, 10)
      : parseInt(body.getAttribute('data-bac-plan-ship-frequency'), 10);
    checkout.frequency = mapShipFrequencyToFlowFrequency(checkout.shipFrequency);

    var subtotalEl = body.querySelector('[data-bac-plan-subtotal]');
    checkout.subTotal = subtotalEl ? subtotalEl.textContent.trim() : '';

    var flow = getFlow();
    var cardSpType = card.getAttribute('data-sp-type') || '';
    checkout.productType =
      cardSpType ||
      (selection && selection.spType) ||
      (selection && selection.productType) ||
      card.getAttribute('data-bac-product-type') ||
      (flow.getActiveSpType && flow.getActiveSpType()) ||
      (flow.resolveProductTypeFromSpType &&
        flow.resolveProductTypeFromSpType(cardSpType)) ||
      flow.productType ||
      'core';
    checkout.productSize = row.variant_title;

    checkout.giftVariantId = resolveGiftVariantIdForCheckout(card, body);
    checkout.giftNote = '';
    checkout.crateName = getCrateNameFromSelection();
    checkout.crateSKU = resolveCrateSku();

    return true;
  }

  function getActivePlanCard() {
    if (dom) {
      var selected = dom.getSelectedPlanCard();
      if (selected) return selected;
    }
    var checkedInput = document.querySelector('[data-bac-plan-card-input]:checked');
    if (!checkedInput) return null;
    var card = checkedInput.closest('[data-plan-card]');
    var visibilityTarget = card ? (card.closest('.swiper-slide') || card) : null;
    if (!card || (dom ? dom.isHidden(card) : visibilityTarget.classList.contains('d-none'))) return null;
    return card;
  }

  function canSubmit() {
    if (!deps) return false;

    var card = getActivePlanCard();
    var purchaseMode = deps.getPurchaseMode();
    if (!card || !deps.isPlanCardConfiguredForPurchaseMode(card, purchaseMode)) return false;

    var body = deps.getPlanProductBodyForMode(card, purchaseMode);
    if (!body || !isPlanProductAvailable(body)) return false;

    var rows = parseVariantRows(body);
    if (!rows || !rows.length) return false;

    var hasShirt = isAddonAdded('shirt');
    if (hasShirt && !getShirtSizeLabelForCheckout()) return false;

    if (hasCrateSelectionRequired() && !document.querySelector('[data-bac-crate-radio]:checked')) {
      return false;
    }

    var shirtSize = getShirtSizeLabelForCheckout();
    var row = pickVariantRow(rows, shirtSize);
    return !!(row && row.variant_id);
  }

  function updateSubmitState() {
    var btn = document.querySelector('[data-submit-build-a-crate]');
    if (!btn) return;

    var card = getActivePlanCard();
    var purchaseMode = deps ? deps.getPurchaseMode() : 'subscribe';
    var body = card && deps ? deps.getPlanProductBodyForMode(card, purchaseMode) : null;
    var isSoldOut = !!(body && !isPlanProductAvailable(body));
    var valid = !isSoldOut && canSubmit();

    if (dom) {
      dom.setAtcState(btn, { soldout: isSoldOut, disabled: !valid });
    } else {
      btn.classList.toggle('soldout', isSoldOut);
      btn.classList.toggle('disabled', !valid);
      btn.disabled = !valid;
    }

    if (valid) {
      syncCheckout();
    }
  }

  function getCartAddUrl() {
    var base = '/cart/add';
    if (typeof routes !== 'undefined' && routes.cart_add_url) {
      base = routes.cart_add_url;
    }
    return base.slice(-3) === '.js' ? base : base + '.js';
  }

  async function parseCartAddError(response) {
    var message = 'Cart add failed';
    try {
      var text = await response.text();
      if (!text) return message;
      try {
        var data = JSON.parse(text);
        if (data && (data.description || data.message)) {
          message = [data.message, data.description].filter(Boolean).join(': ');
        }
      } catch (parseErr) {
        message = text.slice(0, 300);
      }
    } catch (readErr) {
      /* ignore */
    }
    return message;
  }

  function resetAtcButton(btn) {
    if (!btn) return;
    if (dom) {
      dom.setAtcState(btn, { loading: false, disabled: !canSubmit() });
    } else {
      btn.classList.remove('loading');
      btn.disabled = !canSubmit();
    }
    if (deps && deps.updateTotalPrice) {
      deps.updateTotalPrice();
    }
  }

  async function addToCart() {
    syncCheckout();
    var checkout = ensureCheckoutState();
    if (!checkout.variantId) {
      throw new Error('Missing checkout variant');
    }

    var card = getActivePlanCard();
    checkout.giftVariantId = resolveGiftVariantIdForCheckout(
      card,
      card && deps ? deps.getPlanProductBodyForMode(card, deps.getPurchaseMode()) : null
    );

    if (
      card &&
      card.getAttribute('data-enable-gifting') === 'true' &&
      !Number.isFinite(checkout.giftVariantId)
    ) {
      console.warn('[Build A Crate] Gift enabled on plan but no gift variant resolved', {
        blockId: card.getAttribute('data-bac-plan-block-id'),
        spType: card.getAttribute('data-sp-type'),
        payFrequency: card.getAttribute('data-pay-frequency'),
        cardGiftAttr: card.getAttribute('data-bac-gift-variant-id')
      });
    }

    var items = [];
    var giftPairId = 'gift_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);

    if (Number.isFinite(checkout.giftVariantId)) {
      var giftProperty = {
        _main_product_auto_renew_id: String(checkout.variantId),
        _gift_pair_id: giftPairId,
        _isGiftProduct: 'true'
      };
      if (checkout.giftNote) {
        giftProperty.Note = checkout.giftNote;
      }
      items.push({
        quantity: 1,
        id: checkout.giftVariantId,
        properties: giftProperty
      });
    }

    if (typeof ttq !== 'undefined' && ttq && typeof ttq.track === 'function') {
      ttq.track('AddToCart', {
        content_id: checkout.variantId,
        quantity: 1,
        value: checkout.subTotal,
        currency: 'USD'
      });
    }

    var firstCrateSku = resolveCrateSku() || checkout.crateSKU || checkout.crateName || '';

    // Block ATC and redirect when First Crate SKU is exactly "surprise"
    if (firstCrateSku === 'surprise') {
      window.location.href = '/pages/join-the-team';
      return;
    }

    var lineProperties = {
      type_of_subscription: checkout.frequency,
      product_type: checkout.productType,
      _gift_pair_id: giftPairId,
      'First Crate SKU': firstCrateSku,
      order_tag: firstCrateSku
    };

    if (isAddonAdded('shirt')) {
      var shirtSizeLabel = getShirtSizeLabelForCheckout();
      if (shirtSizeLabel) {
        lineProperties['Shirt Size'] = shirtSizeLabel;
      }
    }

    if (Number.isFinite(checkout.selling_plan_id)) {
      lineProperties.is_subscrption = true;
    }

    if (global.globalVariables && global.globalVariables.first_crate_title != null) {
      lineProperties['First Crate'] = global.globalVariables.first_crate_title;
    }

    if (checkout.discount_type) {
      lineProperties['Discount Type'] = checkout.discount_type;
    }
    if (checkout.discount_code) {
      lineProperties['Discount code'] = checkout.discount_code;
    }
    if (checkout.discount_amount) {
      lineProperties['Discount value'] = checkout.discount_amount;
    }

    var mainLineItem = {
      quantity: 1,
      id: checkout.variantId,
      properties: lineProperties
    };
    if (Number.isFinite(checkout.selling_plan_id)) {
      mainLineItem.selling_plan = checkout.selling_plan_id;
    }
    items.push(mainLineItem);

    var response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    if (!response.ok) {
      var cartError = await parseCartAddError(response);
      console.error('[Build A Crate] Cart add failed', {
        status: response.status,
        message: cartError,
        items: items,
        purchaseMode: deps.getPurchaseMode()
      });
      throw new Error(cartError);
    }

    if (checkout.discount_code) {
      global.location.href =
        '/discount/' + encodeURIComponent(checkout.discount_code) +
        '?v=' + Date.now() + '&redirect=/checkout/';
      return;
    }
    global.location.href = '/checkout';
  }

  function register(registerDeps) {
    deps = registerDeps;
    ensureCheckoutState();

    var flow = getFlow();
    flow.syncBuildACrateCheckout = syncCheckout;
    flow.addBuildACrateToCart = addToCart;
    flow.canSubmitBuildACrate = canSubmit;
    flow.updateBuildACrateSubmitState = updateSubmitState;
    flow.getActivePlanCard = getActivePlanCard;
    flow.resolveBuildACrateSku = resolveCrateSku;
    flow.resolveGiftVariantIdForCard = function(card) {
      if (!card || card.getAttribute('data-enable-gifting') !== 'true') return null;
      var body = deps ? deps.getPlanProductBodyForMode(card, deps.getPurchaseMode()) : null;
      return resolveGiftVariantIdForCheckout(card, body);
    };

    updateSubmitState();
  }

  global.BuildACrateCart = {
    register: register
  };
})(typeof window !== 'undefined' ? window : this);
